import {
  Archive, ArchiveRestore, ArrowLeft, Building2, CalendarClock, Check, ChevronDown, CircleAlert, CircleCheck,
  Cloud, Code, Copy, CreditCard, Database, Dices, Dot, Download, Eye, EyeOff, File, Folder, FolderPlus, FolderX,
  Globe, Inbox, Info, KeyRound, Layers, Link, Link2Off, Lock, LockKeyhole, Mail, Paperclip, Pencil, Plus,
  RefreshCw, Search, Server, Settings, ShieldCheck, ShoppingBag, Smartphone, Stethoscope, StickyNote, Terminal,
  Ticket, Timer, Trash2, TriangleAlert, Upload, UserCog, UserPlus, UserRound, UserX, Users, X,
  type LucideIcon,
} from "lucide-react";
import type { CSSProperties } from "react";

// Lucide icons by the kebab-case names the design uses.
const ICONS: Record<string, LucideIcon> = {
  archive: Archive,
  "archive-restore": ArchiveRestore,
  "arrow-left": ArrowLeft,
  "building-2": Building2,
  "calendar-clock": CalendarClock,
  check: Check,
  "chevron-down": ChevronDown,
  "alert-circle": CircleAlert,
  "check-circle": CircleCheck,
  cloud: Cloud,
  code: Code,
  copy: Copy,
  "credit-card": CreditCard,
  database: Database,
  dices: Dices,
  dot: Dot,
  download: Download,
  eye: Eye,
  "eye-off": EyeOff,
  file: File,
  folder: Folder,
  "folder-plus": FolderPlus,
  "folder-x": FolderX,
  globe: Globe,
  inbox: Inbox,
  info: Info,
  "key-round": KeyRound,
  layers: Layers,
  link: Link,
  "link-2-off": Link2Off,
  lock: Lock,
  "lock-keyhole": LockKeyhole,
  mail: Mail,
  paperclip: Paperclip,
  pencil: Pencil,
  plus: Plus,
  "refresh-cw": RefreshCw,
  search: Search,
  server: Server,
  settings: Settings,
  "shield-check": ShieldCheck,
  "shopping-bag": ShoppingBag,
  smartphone: Smartphone,
  stethoscope: Stethoscope,
  "sticky-note": StickyNote,
  terminal: Terminal,
  ticket: Ticket,
  timer: Timer,
  "trash-2": Trash2,
  "alert-triangle": TriangleAlert,
  upload: Upload,
  "user-cog": UserCog,
  "user-plus": UserPlus,
  "user-round": UserRound,
  "user-x": UserX,
  users: Users,
  x: X,
};

export function Icon({
  name,
  size = 16,
  style,
  title,
}: {
  name: string;
  size?: number;
  style?: CSSProperties;
  title?: string;
}) {
  const C = ICONS[name] ?? Dot;
  return (
    <C
      size={size}
      strokeWidth={2}
      style={{ flexShrink: 0, ...style }}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    />
  );
}
